<template>
  <div class="chat-history elevation-1">
    <v-toolbar class="chat-history-toolbar" flat color="white">
      <v-text-field flat full-width clearable v-model="search" prepend-icon="search" v-on:keyup.enter="onEnter" label="Suche"></v-text-field>
    </v-toolbar>
    <jw-pagination :items="worklistData" :pageSize=50 :maxPages=4 @changePage="onChangePage" class="d-flex"></jw-pagination>
    <vue-perfect-scrollbar class="chat-history--scrollbar">
      <v-list two-line class="chat-history--list">
        <v-subheader>Verhandlungen</v-subheader>
        <transition-group name="list">
        <template v-for="(item, index) in filteredList">
          <v-hover v-slot:default="{ hover }" :key="index">
          <v-list-tile class="chat-list" avatar :key="item.supplierQuotationNo + index" :to="chatRoute(item.UUID)"  :class="{active:$route.params.uuid  == item.UUID}">
            <v-list-tile-avatar :color="item.negotiationStatus">             
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="black--text">{{item.requestNo}}</v-list-tile-title>
              <v-list-tile-sub-title>{{item.supplierQuotationNo}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="item.negotiationStatus==='open' && item.expireDate">offen bis {{formatExpireDate(item.expireDate)}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-else-if="item.negotiationStatus==='open' && !item.expDate">offen</v-list-tile-sub-title>
              <v-list-tile-sub-title v-else-if="item.negotiationStatus==='started' && item.expireDate">offen bis {{formatExpireDate(item.expireDate)}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-else-if="item.negotiationStatus==='started' && !item.expDate">offen</v-list-tile-sub-title>
              <v-list-tile-sub-title v-else>{{translatedStatus[item.negotiationStatus]}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ formatChatTime(item.createDate) }}
              </v-list-tile-action-text>
            </v-list-tile-action>
            <template v-if="isTest">              
              <v-btn icon @click.prevent="deleteWorklistItem(index, $event)" v-if="hover">
                <v-icon color="red">delete</v-icon>
              </v-btn>
             </template>
          </v-list-tile>
          </v-hover>
        </template>
        </transition-group>
      </v-list>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import API from '@/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import JwPagination from 'jw-vue-pagination'
import { backendUrl } from '../../../config/config.js'

export default {
  components: {
    VuePerfectScrollbar,
    JwPagination
  },

  data: () => ({
    worklistData: [],
    search: '',
    searchResult: {},
    pageOfItems: [],
    pressed: false,
    translatedStatus: {
      'expired': 'abgelaufen',
      'escalation': 'abgelehnt',
      'success': 'erfolgreich'
    }
  }),
  mounted () {
    this.getWorklist()
    this.$root.$off("filter")
    this.$root.$on("filter", data => {
      this.getFiltredWorklist(data)
    })
  },
  methods: {
    // get worklist entries from DB and current status
    async getWorklist () {
      this.worklistData = await API.getWorklist()
    },
    chatRoute (id) {
      return `/chat/messaging/${id}`
    },
    setActive (id) {
        this.selected = id;
    },
    firstLetter (title) {
      if(title) {
        return title.charAt(0)
      } else {
        return ""; 
      }
    },
    // transform firestore date to js date
    getDate (s) {
      if (typeof(s) === 'string') {
        var t = new Date(s) 
      } else if (typeof(s) === 'object') {
        var t = new Date(1970, 0, 1) 
        t.setSeconds(s._seconds)
      }
      return t
    },
    // display date /wo time
    formatChatTime (s) {
      if(s) {
        var t = this.getDate(s)
        return t.toLocaleDateString()
      } else {
        return ""
      }
    },
    formatExpireDate (s) {
      if(s) {
        var t = this.getDate(s)
        return t.toLocaleString()
      } else {
        return ""
      }
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    async getFiltredWorklist(query){
      this.worklistData = await API.getWorklistByQuery(query)
    },
    async deleteWorklistItem(i, event){
      let target = event.target
      while(target.childElementCount != 0){
        target = target.children[0]
      }
      if(target.innerText == "delete"){
        target.innerText = "check"
      }else{
        let res = await API.deleteWorklist(this.worklistData[i].UUID)
        this.worklistData.splice(i, 1)
      }
    },
    onEnter: function() {
       this.pressed = true;
    }
  },
  computed: {
    filteredList () {
      if (this.search && this.search.length > 1 && this.pressed === true) {
        let searchString = this.search.toLowerCase();
        this.pressed = false;
        return this.worklistData.filter(item => {
              const containsCart = item.requestNo ? item.requestNo.toLowerCase().includes(searchString) : false
              const containsQuotationNo = item.supplierQuotationNo ? item.supplierQuotationNo.toLowerCase().includes(searchString) : false
              return (containsCart || containsQuotationNo)
            });

      } else {
        this.pressed = false;
        return this.pageOfItems
      }
      
    },
    isTest() {
      if(backendUrl.includes("localhost") || backendUrl.includes("dev")) {
        return true;
      } else {
        return false;
      }      
    }
  }
}
</script>
<style>
  .active {
    font-size:16px;
    font-weight: bold;
  }
  .chat-list.active {
    background: rgb(95, 42, 42);
    
  }
  .list-enter-active,
  .list-leave-active,
  .list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
  }

  .list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
  }

  .list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
  }

  .list-leave-active {
    position: absolute;
  }

  .list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
  }
</style>
